import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "on_pn" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "tt_page" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Thêm tài khoản nhân viên")
], -1)
const _hoisted_3 = { class: "on_dskb" }
const _hoisted_4 = { class: "wrap" }
const _hoisted_5 = { class: "on_choose" }
const _hoisted_6 = { class: "on_it" }
const _hoisted_7 = { class: "it_3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Chọn tài khoản:", -1)
const _hoisted_9 = {
  class: "flex align-items-center",
  style: {"width":"40px","alignment":"center"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { style: {"width":"40px","alignment":"top"} }
const _hoisted_12 = { class: "it_3 it_ccc" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoa/phòng", -1)
const _hoisted_14 = { class: "it_3 it_bk" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.customer,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.customer) = $event)),
                options: $setup.listCustomer,
                optionLabel: "name",
                placeholder: "Chọn tài khoản",
                filter: true,
                style: {"height":"35px"}
              }, {
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_9, [
                    (slotProps.option.imageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: slotProps.option.imageUrl,
                          style: {"width":"40px","margin-right":"3px"}
                        }, null, 8, _hoisted_10))
                      : _createCommentVNode("", true),
                    _createElementVNode("label", _hoisted_11, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.teamId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.teamId) = $event)),
                options: $setup.teams,
                optionLabel: "name",
                optionValue: "code",
                placeholder: "Chọn khoa/ phòng",
                filter: true
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_Button, {
                label: "Đăng ký",
                icon: "pi pi-plus-circle",
                iconPos: "left",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.doRegister()))
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}